export var ChatModel;
(function (ChatModel) {
    ChatModel["GPT_4_1"] = "gpt-4.1-2025-04-14";
    ChatModel["GPT_4_1_NANO"] = "gpt-4.1-nano-2025-04-14";
})(ChatModel || (ChatModel = {}));
